<template>
  <div class="expert-jion">
    <navigation></navigation>
    <div style="width: 100%; height: 80px"></div>

    <div class="expert-jion-wrap">
      <!-- 真实姓名 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          真实姓名
        </div>
        <div class="userinfor" style="float: left">
          {{ userInfor.realName }}
        </div>
      </div>
      <!-- 性别 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 12px;
            line-height: 12px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          性别
        </div>
        <div style="float: left; width: 350px; height: 12px; line-height: 12px">
          <img
            :src="img2"
            alt=""
            style="
              display: block;
              width: 12px;
              height: 12px;
              float: left;
              margin-right: 10px;
              cursor: pointer;
            "
            v-if="sexFlag == 0"
          />
          <div
            style="float: left; margin-right: 40px; font-size: 12px"
            v-if="sexFlag == 0"
          >
            男
          </div>
          <img
            :src="img2"
            alt=""
            style="
              display: block;
              width: 12px;
              height: 12px;
              float: left;
              margin-right: 10px;
              cursor: pointer;
            "
            v-if="sexFlag == 1"
          />
          <div style="float: left; font-size: 12px" v-if="sexFlag == 1">女</div>
        </div>
      </div>
      <!-- 行业 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          行业
        </div>
        <div class="iselect" style="float: left">
          <Select
            v-model="sel_territory"
            style="width: 200px"
            placeholder="请选择所属行业"
          >
            <Option
              v-for="item in industryList"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </div>
      </div>
      <!-- 政治面貌 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          政治面貌
        </div>
        <div class="iselect" style="float: left">
          <Select
            v-model="sel_politic"
            style="width: 200px"
            placeholder="请选择您的政治面貌"
          >
            <Option v-for="item in politicsList" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </div>
      </div>
      <!-- 学历 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          请选择您的学历
        </div>
        <div class="iselect" style="float: left">
          <Select
            v-model="sel_qualifications"
            style="width: 200px"
            placeholder="请选择您的学历"
          >
            <Option v-for="item in educationList" :value="item" :key="item">{{
              item
            }}</Option>
          </Select>
        </div>
      </div>

      <!-- 联系电话 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          联系电话
        </div>
        <div class="userinfor" style="float: left">
          {{ userInfor.phoneNum }}
        </div>
      </div>
      <!-- 邮箱账号 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          邮箱账号
        </div>
        <div class="userinfor" style="float: left">
          {{ userInfor.email }}
        </div>
      </div>
      <!-- 职称 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          职称
        </div>
        <div class="userinput" style="float: left">
          <input
            type="text"
            placeholder="请输入您的职称"
            ref="unit1"
            @blur="jobFn"
          />
        </div>
      </div>
      <!-- 社会团体及职务 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          社会团体及职务
        </div>
        <div class="userinput" style="float: left">
          <input
            type="text"
            placeholder="请输入您的社会团体及职务"
            ref="unit2"
          />
        </div>
      </div>
      <!-- 工作单位 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          工作单位
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入您的工作单位" ref="unit3" />
        </div>
      </div>
      <!-- 工作岗位/职务 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          工作岗位/职务
        </div>
        <div class="userinput" style="float: left">
          <input
            type="text"
            placeholder="请输入您的工作岗位/职务"
            ref="unit4"
          />
        </div>
      </div>
      <!-- 通讯地址 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          通讯地址
        </div>
        <div class="userinput" style="float: left">
          <input type="text" placeholder="请输入您的通讯地址" ref="address" />
        </div>
      </div>
      <!-- 个人简介 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          个人简介
        </div>
        <div style="float: left; width: 350px">
          <textarea
            placeholder="请输入您的个人简介（最多不超过500字）"
            v-model="individualResume"
            maxlength="500"
            style="
              width: 350px;
              height: 200px;
              background: rgba(250, 250, 250, 1);
              border: 1px solid rgba(238, 238, 238, 1);
              border-radius: 4px;
              outline: none;
              padding: 18px 9px;
            "
            @blur="individualResumeFn"
          >
我是一个文本框。</textarea
          >
        </div>
      </div>

      <!-- 证件照片 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 100px;
            line-height: 100px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          证书照片
        </div>
        <div style="width: 350px; overflow: hidden; float: left">
          <el-upload
            class="upload-nine"
            action="/v1/cloud/user/expert/upload/certificate"
            :on-preview="handlePreview"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :file-list="fileList"
            :multiple="true"
            :limit="9"
            list-type="picture"
          >
            <!-- <el-button size="small" type="primary">点击上传</el-button> -->
            <div
              style="
                width: 170px;
                height: 100px;
                position: relative;
                background: rgba(250, 250, 250, 1);
                border: 1px solid rgba(238, 238, 238, 1);
                border-radius: 4px;
              "
            >
              <img
                src="../../static/common/upload_image.png"
                style="
                  dispaly: block;
                  width: 34px;
                  height: 33px;
                  margin: 0px 67px;
                  position: absolute;
                  left: 0px;
                  top: 24px;
                "
              />
              <div
                style="
                  color: #3476C1;
                  position: absolute;
                  left: 0px;
                  top: 69px;
                  width: 170px;
                  text-align: center;
                "
              >
                点击此处上传
              </div>
              <div
                style="
                  position: absolute;
                  left: 190px;
                  top: 44px;
                  width: 114px;
                  height: 12px;
                  line-height: 12px;
                  font-size: 12px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: #666666;
                "
              >
                <span>最多可上传</span>
                <span style="color: #3476C1"> 9 </span>
                <span>个附件</span>
              </div>
            </div>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
          </el-upload>
        </div>
      </div>
      <!-- 封面照片 -->
      <div style="overflow: hidden; margin-top: 20px">
        <div
          style="
            float: left;
            width: 85px;
            text-align: right;
            margin-right: 30px;
            height: 100px;
            line-height: 100px;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          封面照片
        </div>
        <div style="width: 400px; overflow: hidden; float: left">
          <div style="width: 100%; overflow: hidden">
            <el-upload
              class="avatar-uploader"
              action="/v1/cloud/user/expert/upload/img"
              :show-file-list="false"
              :on-success="handleSuccess2"
              :on-error="handleError2"
              :before-upload="beforeAvatarUpload2"
            >
              <img v-if="coverImage" :src="coverImage" class="avatar" />
              <div style="width: 170px; height: 100px" v-show="!coverImage">
                <img
                  src="../../static/common/upload_image.png"
                  style="
                    dispaly: block;
                    width: 34px;
                    height: 33px;
                    margin: 0px 67px;
                    position: absolute;
                    left: 0px;
                    top: 24px;
                  "
                />
                <div
                  style="
                    color: #3476C1;
                    position: absolute;
                    left: 0px;
                    top: 24px;
                    width: 170px;
                    text-align: center;
                  "
                >
                  点击此处上传
                </div>
              </div>
            </el-upload>
            <div
              style="
                width: 218px;
                float: left;
                height: 100px;
                margin-left: 10px;
              "
              v-show="!coverImage"
            >
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 43px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(154, 154, 154, 1);
                "
              >
                可上传png、jpg、gif、pdf等格式的图片
              </div>
            </div>
            <div
              style="
                width: 218px;
                float: left;
                height: 100px;
                margin-left: 10px;
              "
              v-show="coverImage"
            >
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 33px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(154, 154, 154, 1);
                "
              >
                可上传png、jpg、gif、pdf等格式的文件
              </div>
              <div
                style="
                  font-size: 12px;
                  line-height: 12px;
                  margin-top: 10px;
                  font-family: MicrosoftYaHei;
                  font-weight: 400;
                  color: rgba(154, 154, 154, 1);
                "
              >
                如需更换图片，请点击图片可再次上传
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 清除浮动 -->
      <div style="clear: both"></div>
      <!-- <div class="errortext">
            {{errortext}}
        </div> -->
      <!-- 协议 -->
      <div
        style="
          width: 350px;
          height: 12px;
          line-height: 12px;
          margin-top: 40px;
          margin-left: 115px;
        "
      >
        <img
          :src="agreementFlag == 1 ? img2 : img1"
          alt=""
          style="
            display: block;
            width: 12px;
            height: 12px;
            float: left;
            margin-right: 10px;
            cursor: pointer;
          "
          @click="isOrFn('agreement', 1)"
        />
        <div
          style="
            float: left;
            width: 252px;
            height: 12px;
            font-size: 12px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
          "
        >
          <span style="color: #999999">我已确认并同意</span>
          <span style="color: #3476C1">《专家入驻协议》</span>
          <span style="color: #999999">中事项和要求</span>
        </div>
      </div>

      <div class="go" @click="submitFn()">入驻</div>
    </div>

    <div style="width: 100%; height: 100px"></div>
  </div>
</template>

<script>
// import helloworld from '@/components/helloworld.vue' //引入组件
import navigation from "@/components/common/navigation";

export default {
  name: "expertJoin",
  components: {
    navigation,
  },
  data() {
    return {
      userInfor: {},
      img1: require("../../static/login/i6.png"), //单选图标
      img2: require("../../static/login/i7.png"),
      sexFlag: 0, //性别
      crowdList: ["小学生", "中学生", "大学生"],
      //行业领域
      // businessList:['移动互联网','电子商务','社区社交','教育培训','汽车交通','旅游','硬件','工具软件','企业服务','医疗健康','生活消费','农业','物流网','人工智能','区块链','环保','金融','生活服务','消费','文化娱乐','体育','信息通信','传统行业','材料','能源电力','社区服务','生态农业','人力资源','母婴'],
      industryList: [],
      //政治面貌
      politicsList: [
        "中共党员",
        "中共预备党员",
        "共青团员",
        "民革党员",
        "民盟盟员",
        "民建会员",
        "民进会员",
        "农工党党员",
        "致公党党员",
        "九三学社社员",
        "台盟盟员",
        "无党派人士",
        "群众",
      ],
      //学历列表
      educationList: [
        "博士研究生",
        "硕士研究生",
        "本科",
        "专科（高职/高专/高技）",
        "高级中学（中师/中专/职高/中技/普通高级中学）",
        "初级中学",
        "小学",
      ],
      fileList: [],
      uploadList: [],
      coverImage: "",
      uploadCover: "",
      sel_territory: "",
      sel_qualifications: "",
      sel_politic: "",
      individualResume: "", //个人简介
      agreementFlag: 0, //是否同意协议
    };
  },
  methods: {
    handlePreview(file) {
      console.log(file);
    },
    handleError(err, file, fileList) {
      // console.log('000',err,file, fileList);
    },
    handleRemove(file, fileList) {
      console.log(111, file, fileList);
      let list = [];
      if (fileList) {
        fileList.forEach((item, index, array) => {
          list.push(item.response);
        });
      }
      this.uploadList = list;
      //删除服务器上图片
      let imgUrl = file.response.imgUrl;
      this.$axios
        .post("/v1/cloud/user/expert/upload/certificate/delete", {
          url,
        })
        .then(({ data }) => {})
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });

      console.log(111, this.uploadList, list);
    },
    handleError2(res) {
      if (res.status == 401) {
        this.$router.push({ name: "login" });
      }
    },
    handleSuccess(res, file, fileList) {
      console.log(222, res, file, fileList);
      let list = [];
      if (fileList) {
        fileList.forEach((item, index, array) => {
          list.push(item.response);
        });
      }
      this.uploadList = list;
      console.log(222, this.uploadList, list);
    },
    handleSuccess2(res, file) {
      this.coverImage = URL.createObjectURL(file.raw);
      this.uploadCover = res;
    },
    beforeAvatarUpload2(file) {
      // const isJPG = file.type === 'image/jpeg';
      // const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      // this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      // if (!isLt2M) {
      // this.$message.error('上传头像图片大小不能超过 2MB!');
      // }
      // return isJPG && isLt2M;
    },
    toExpert() {
      this.$router.push("/Expert");
    },
    isOrFn(type, val) {
      console.log(type);
      if (type == "1") {
        this.isOr1 = val;
      } else if (type == "2") {
        this.isOr2 = val;
      } else if (type == "3") {
        this.isOr3 = val;
      } else if (type == "4") {
        this.isOr4 = val;
      } else if (type === "agreement") {
        if (this.agreementFlag === 1) {
          this.agreementFlag = 0;
        } else {
          this.agreementFlag = 1;
        }
      } else {
      }
    },
    identityFn(type, val) {
      if (type == "identity") {
        this.identityFlag = val;
      } else if (type == "sex") {
        this.sexFlag = val;
      } else if (type == "state") {
        this.state = val;
      } else {
      }
    },
    jobFn() {
      // let value = this.$refs.unit1.value;
      // if(/^[0-9]+$/.test(value)){
      //     this.$message.error('不能全为数字！');
      // }else if(/^[a-zA-Z]+$/.test(value)){
      //     this.$message.error('不能全为字母！');
      // }
    },
    individualResumeFn() {
      if (this.individualResume.length > 500) {
        this.$message.error("最多不超过500字！");
      } else {
      }
    },
    submitFn() {
      let param = {
        territory: this.sel_territory, // 领域
        qualifications: this.sel_qualifications, // 学历
        politic: this.sel_politic, // 政治面貌

        positionName: this.$refs.unit1.value, // 职称
        socialGroups: this.$refs.unit2.value, // 社会团体
        dutiesName: this.$refs.unit4.value, // 工作岗位职务

        workUnit: this.$refs.unit3.value, // 工作单位
        address: this.$refs.address.value, // 通讯地址
        remark: this.individualResume, // 个人简介

        ownPhoto: this.uploadCover, // 自己的照片 - 封面照片
        credentialsImgList: this.uploadList, // 资格证照片
      };
      console.log(param, 777);
      this.$axios
        .post("/v1/cloud/user/expert/into", param)
        .then(({ data }) => {
          if (data) {
            this.$message({
              showClose: true,
              message: "您的资料已提交，将在1-3个工作日内进行审核。",
              type: "success",
            });
            this.$router.push("/expert");
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        });
    },
  },
  created() {
    this.$axios
      .get("/v1/cloud/user/expert/into/before/msg", {})
      .then(({ data }) => {
        if (data) {
          this.userInfor = data;
        }
      })
      .catch((error) => {
        var err = error.response;
        if (err.status == 400) {
          this.$Message.error(err.data.message);
        }
        if (err.status == 401) {
          this.$router.push({ name: "login" });
        }
      });
    //行业  industry
    this.$axios.get("/v1/cloud/common/industry").then(({ data }) => {
      if (data) {
        data.shift();
        this.industryList = data;
      }
    });
  },
  mounted() {
    //滚动条从顶部开始
    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (osTop > 0) {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    }
  },
};
</script>

<style lang="less">
::-webkit-input-placeholder {
  color: #999999 !important;
  font-family: MicrosoftYaHei;
}
.ivu-select-selection {
  height: 40px !important;
  line-height: 40px !important;
}
.ivu-select-placeholder,
.ivu-select-selected-value {
  height: 40px !important;
  line-height: 40px !important;
}
//最多上传九个图片
// .upload-nine{
//     width:170px;float: left;
// }
//上传图片
.avatar-uploader .el-upload {
  // border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  float: left;
  width: 170px !important;
  height: 100px !important;
  line-height: 100px !important;
  background: rgba(250, 250, 250, 1);
  border: 1px solid rgba(238, 238, 238, 1);
}
.avatar-uploader-l .el-upload {
  margin-left: 8px;
}
// .avatar-uploader .el-upload:hover {
//     border-color: #409EFF;
// }
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 182px;
  height: 115px;
  line-height: 115px;
  text-align: center;
}
.avatar {
  width: 182px;
  height: 115px;
  display: block;
}

input {
  outline: none;
  border: none;
  background: rgba(0, 0, 0, 0);
}
.expert-jion {
  width: 100%;
  background-color: #f5f5f5;
  .expert-jion-wrap {
    width: 1200px;
    height: auto;
    margin: 0 auto;
    padding-left: 345px;
    margin-top: 30px;
    overflow: hidden;
    border-radius: 4px;
    background: #fff;
    border: 1px solid rgba(238, 238, 238, 1);
    .userinput {
      width: 350px;
      height: 40px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 9px;
      input {
        float: left;
        width: 300px;
        height: 100%;
      }
    }
    .userinfor {
      width: 350px;
      height: 40px;
      line-height: 40px;
      background: rgba(250, 250, 250, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 4px;
      padding-left: 4px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(154, 154, 154, 1);
    }
    .iselect {
      .ivu-select {
        width: 350px !important;
        height: 50px !important;
        line-height: 50px;
      }
      .ivu-select-selection {
        height: 50px;
        line-height: 50px;
        background: rgba(250, 250, 250, 1);
      }
      .ivu-select-single .ivu-select-selection {
        outline: none;
        width: 350px;
        height: 50px;
        line-height: 50px;
      }
      .ivu-select-single .ivu-select-selection .ivu-select-placeholder,
      .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
        width: 350px;
        height: 50px;
        line-height: 50px;
      }
    }
    .go {
      margin-top: 20px;
      margin-bottom: 50px;
      margin-left: 115px;
      width: 350px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #3476C1;
      border-radius: 4px;
      cursor: pointer;
      font-size: 18px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>